import { ColumnDef } from '@tanstack/react-table'
import { GetChannelTableData } from '@/modules/manage-player/type'
import { UpdateChannelFormModal } from './CellAction/components/UpdateChannelFormModal'
import { IsActiveChannel } from './CellAction/components/IsActiveChannel'
import { Link } from 'react-router-dom'
import { Button } from '@/common/ui/button'
import { Pencil } from 'lucide-react'
import { DeleteChannelDialog } from './CellAction/components/DeleteChannelDialog'

export const columns: ColumnDef<GetChannelTableData>[] = [
	{
		accessorKey: 'name',
		header: 'ชื่อช่องทาง',
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveChannel row={row.original} />,
	},
	{
		accessorKey: 'promotion.name',
		header: 'โปรโมชั่นที่ใช้',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<span>{row.original.promotion?.name || '-'}</span>
				<Link
					to={`/operator/deposit-promotion/${row.original.promotion?.id || ''}`}
				>
					<Button variant="ghost" size="icon">
						<Pencil className="h-4 w-4" />
					</Button>
				</Link>
			</div>
		),
	},

	{
		accessorKey: 'link',
		header: 'ลิงค์',
	},
	{
		accessorKey: 'playerCount',
		header: 'จำนวนผู้ใช้งาน',
	},
	{
		accessorKey: 'note',
		header: 'หมายเหตุ',
		cell: ({ row }) => row.original.note || '-',
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
	},
	{
		id: 'edit',
		header: 'แก้ไข',
		cell: ({ row }) => (
			<UpdateChannelFormModal
				data={{
					...row.original,
					note: typeof row.original.note === 'object' ? '' : row.original.note,
				}}
			/>
		),
	},
	{
		id: 'delete',
		header: 'ลบ',
		cell: ({ row }) => <DeleteChannelDialog data={row.original} />,
	},
]

export const writeAccessorKeys = ['edit', 'delete', 'isActive']
